import { useState, Suspense, lazy } from "react";
import "./App.css";

//COMPONENTS
import Header from "./components/Header/Header";
import SectionCalls from "./components/SectionCalls/SectionCalls";
// import Downloads from "./components/Downloads/Downloads";
import Contato from "./components/Contato/Contato";
import Sections from "./components/Sections/Sections";
import About from "./components/About";
import Footer from "./components/Footer/Footer";
import Slideshow from "./components/Slideshow";
// import Scanner from "./components/Scanner/Scanner";
import Card from "./components/Card";

const Scanner = lazy(() => import("./components/Scanner/Scanner"));
const Downloads = lazy(() => import("./components/Downloads/Downloads"));

// IMAGENS
// import balanca from "./img/CardViewer/balanca.png";
// import office from "./img/CardViewer/logo.png";
// import oryon from "./img/CardViewer/logo_oryon.png";
// import secullum from "./img/CardViewer/Secullum.png";
// import controlid from "./img/CardViewer/idclass.png";
// import windows from "./img/CardViewer/windows.png";
// import PC from "./img/CardViewer/NTC Home - Frontal_Lateral.png";
// import el250 from "./img/CardViewer/el250.png";

// import Slideshow from "./components/Slideshow";
// import CardViewer from "./components/CardViewer/CardViewer";

// Dados para o mapeamento
// const cardViewers = [
//   {
//     customID: "Balancas",
//     nome: "BALANÇAS",
//     image: balanca,
//   },
//   {
//     customID: "SistemasGestao",
//     nome: "SISTEMAS DE GESTÃO",
//     image: office,
//     image2: oryon,
//   },
//   {
//     customID: "ControlePonto",
//     nome: "CONTROLE DE PONTO",
//     image: secullum,
//     image2: controlid,
//   },
//   { customID: "Servicos", nome: "SERVIÇOS", image: windows },
//   { customID: "Equipamentos", nome: "EQUIPAMENTOS", image: PC, image2: el250 },
// ];

function App() {
  const [selectedSection, setSelectedSection] = useState(0);
  const [isScannerOn, setIsScannerOn] = useState(false);

  const handleScan = (barcode, inventory) => {
    console.log(`Código lido: ${barcode}`);
    // Integre com seu sistema existente aqui
  };

  const handleSelect = (section) => {
    setSelectedSection(section);
  };

  const handleScanner = () => {
    setIsScannerOn(!isScannerOn);
  };

  return (
    <div className="App">
      <Header scannerToggle={handleScanner} />
      <Slideshow />

      {!isScannerOn ? (
        <>
          <SectionCalls onSelect={handleSelect} />
          <About />
          <Suspense fallback={<div>Carregando opções de download...</div>}>
            <Downloads />
          </Suspense>
          <Sections selectedSection={selectedSection} onSelect={handleSelect} />
          <Contato />
        </>
      ) : (
        <Suspense fallback={<div>Iniciando scanner...</div>}>
          <Card>
            <Scanner
              onScan={handleScan}
              onExport={(inventory) => console.log("Exportado:", inventory)}
              title="Leitor de Estoque"
            />
          </Card>
        </Suspense>
      )}

      <Footer />
    </div>
  );
}

export default App;
